import { useMutation, useReactiveVar } from '@apollo/client'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material'
import { ChangeEvent, useState } from 'react'
import { useParams } from 'react-router-dom'
import { BucketUpdateDocument } from '../../../../graphql/generated'
import { modalVar } from '../../../../providers/apollo/cache'
import logger from '../../../../utils/logger'
import useAlerts from '../../hooks/useAlerts'

export default function BucketRename() {
  const { createAlert } = useAlerts()
  const [bucketTitle, setBucketTitle] = useState('')
  const [loading, setLoading] = useState(false)
  const [mutation] = useMutation(BucketUpdateDocument)
  const bucketTitleTrimmed = bucketTitle.trim()
  const { bucketId } = useParams<{ bucketId: string }>()
  const modal = useReactiveVar(modalVar)

  const handleClose = () => {
    setBucketTitle('')
    modalVar(null)
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value
    setBucketTitle(inputValue)
  }

  const handleClick = () => {
    setLoading(true)
    mutation({
      onCompleted: ({ bucketUpdate }) => {
        if (!bucketUpdate) return
        handleClose()
        createAlert('Your bucket has been renamed', 'success')
        setLoading(false)
      },
      onError: (error) => {
        handleClose()
        logger.error(error)
        if (error.message.includes('My Bucket')) {
          createAlert(error.message, 'error')
        } else {
          createAlert('There was an error updating your bucket.', 'error')
        }
        setLoading(false)
      },
      variables: {
        bucketId: bucketId!,
        data: { title: bucketTitleTrimmed }
      }
    })
  }

  return (
    <div>
      <Dialog open={modal === 'bucketRename'} onClose={handleClose} aria-labelledby="bucket-rename-dialog">
        <DialogTitle id="conversion-dialog-title">Rename your bucket</DialogTitle>
        <DialogContent>
          <DialogContentText id="conversion-dialog-text" style={{ color: 'black' }}>
            Enter a new name for your bucket.
          </DialogContentText>
          <Box mb={1} marginTop={2}>
            <TextField
              name="rename-bucket-title-field-name"
              label="New Bucket Name"
              fullWidth
              required
              autoComplete="off"
              id="rename-bucket-title"
              onChange={handleChange}
              value={bucketTitle}
              placeholder="New Bucket Name"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} color="inherit" onClick={handleClose} autoFocus>
            Cancel
          </Button>
          <Button disabled={!bucketTitleTrimmed.length || loading} onClick={handleClick} variant="contained" sx={{ ml: 2, px: 5 }}>
            Update Name
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
